import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinimize315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minimize-315, arrow, shrink"} maskId="square-filled-radius-0-stroke-1-IconMinimize315"><path fillRule="evenodd" clipRule="evenodd" d="M2.79297 3.50008L9.29297 10.0001H3.00008V11.0001H11.0001V3.00008H10.0001V9.29297L3.50008 2.79297L2.79297 3.50008ZM21.0001 13.0001H13.0001V21.0001H14.0001V14.7072L20.5001 21.2072L21.2072 20.5001L14.7072 14.0001H21.0001V13.0001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinimize315;
